export default __webpack_public_path__ + "static/media/helsinki_xl.31ae54e7.jpg";